import { parseLocalDate } from './dateUtils'

// Paleta solida (texto oscuro encima): rosa, lima, violeta, cielo, rojo, ambar, teal, fucsia.
export const FLYER_PALETTE = [
  '#F9A8D4', '#BEF264', '#C4B5FD', '#7DD3FC', '#FCA5A5', '#FCD34D', '#5EEAD4', '#F0ABFC',
]

const MESES = ['ENE', 'FEB', 'MAR', 'ABR', 'MAY', 'JUN', 'JUL', 'AGO', 'SEP', 'OCT', 'NOV', 'DIC']

export const etiquetaDia = (fechaIso) => {
  if (!fechaIso) return null
  const d = parseLocalDate(fechaIso)
  if (!d) return null
  const dia = d.toLocaleDateString('es-MX', { weekday: 'long' }).toUpperCase()
  const nn = String(d.getDate()).padStart(2, '0')
  return `${dia} ${nn} ${MESES[d.getMonth()]} ${d.getFullYear()}`
}

const hhmm = (h) => (h ? h.slice(0, 5) : null)

// Transforma los juegos del rol (get_rol_jornada) en la rejilla del flyer:
// filas = horas, columnas = campos, cada celda = enfrentamiento(s) local vs visita.
export const buildRolFlyer = (juegos = []) => {
  const conHora = (juegos || []).filter((j) => hhmm(j.hora))

  // Color estable por nombre de categoria.
  const nombres = Array.from(new Set(conHora.map((j) => j.categoria_nombre).filter(Boolean))).sort()
  const colorDe = new Map(nombres.map((n, i) => [n, i % FLYER_PALETTE.length]))
  const categorias = nombres.map((nombre) => ({ nombre, colorIndex: colorDe.get(nombre) }))

  const horas = Array.from(new Set(conHora.map((j) => hhmm(j.hora)))).sort()
  const campos = Array.from(new Set(conHora.map((j) => j.campo || 'Sin campo'))).sort((a, b) =>
    a === 'Sin campo' ? 1 : b === 'Sin campo' ? -1 : a.localeCompare(b, 'es', { numeric: true }),
  )

  // celdas[`${hora}|${campo}`] = [{ local, localLogo, visita, visitaLogo, categoria, colorIndex, marcadorLocal, marcadorVisita, finalizado }]
  const celdas = {}
  for (const j of conHora) {
    const key = `${hhmm(j.hora)}|${j.campo || 'Sin campo'}`
    if (!celdas[key]) celdas[key] = []
    celdas[key].push({
      local: j.local_club || 'Por definir',
      localLogo: j.local_logo || null,
      visita: j.visita_club || 'Por definir',
      visitaLogo: j.visita_logo || null,
      categoria: j.categoria_nombre || 'Sin categoría',
      colorIndex: colorDe.get(j.categoria_nombre) ?? 0,
      marcadorLocal: j.marcador_local,
      marcadorVisita: j.marcador_visita,
      finalizado: j.estatus === 'finalizado',
    })
  }

  const sede = conHora.find((j) => j.sede)?.sede || null
  const fecha = conHora.find((j) => j.fecha)?.fecha || null

  return { sede, fecha, fechaLabel: etiquetaDia(fecha), horas, campos, celdas, categorias }
}
